import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { getAllSimulations } from 'Services';
import { RQ_ALL_SIMULATIONS } from 'Utils';
import { transformSimulations } from '../helper';

function useGetSimulations(users?: UsersHashmap) {
    const { t } = useTranslation();
    return useQuery<Simulation[]>([RQ_ALL_SIMULATIONS], getAllSimulations, {
        select: (simulationsData: SimulationApiResponseObj[]) => {
            return transformSimulations(t, simulationsData, users);
        }
    });
}

export default useGetSimulations;
